var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4961 27.4894H7.50359C4.19275 27.4894 1.51025 24.7948 1.51025 21.484V12.5302C1.51025 10.8869 2.52525 8.82064 3.83025 7.80564L10.3432 2.73064C12.3007 1.20814 15.4303 1.13564 17.4603 2.56147L24.9278 7.79356C26.3657 8.79647 27.4894 10.9473 27.4894 12.6994V21.4961C27.4894 24.7948 24.8069 27.4894 21.4961 27.4894ZM11.4548 4.15647L4.94192 9.23147C4.084 9.90814 3.32275 11.4427 3.32275 12.5302V21.484C3.32275 23.7919 5.19567 25.6769 7.50359 25.6769H21.4961C23.804 25.6769 25.6769 23.804 25.6769 21.4961V12.6994C25.6769 11.5394 24.8432 9.93231 23.8886 9.27981L16.4211 4.04772C15.0436 3.08106 12.7719 3.12939 11.4548 4.15647Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 22.6562C14.0046 22.6562 13.5938 22.2454 13.5938 21.75V18.125C13.5938 17.6296 14.0046 17.2188 14.5 17.2188C14.9954 17.2188 15.4062 17.6296 15.4062 18.125V21.75C15.4062 22.2454 14.9954 22.6562 14.5 22.6562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo8);
export default __webpack_public_path__ + "static/media/logo8.f26c51e5f554d2663c9b22b878447d25.svg";
export { ForwardRef as ReactComponent };